import { call, put, takeEvery, takeLeading } from 'redux-saga/effects';
import userAPI from '../../../../user/api/UserAPI';
import { FETCH_USER_HANDLER_SELECTIONS_REQUEST, DELETE_USER_HANDLER_SELECTION_REQUEST } from '../../../../user/redux/actions/types/UserActionTypes';
import {
  fetchUserHandlerSelectionsFailureActionCreator,
  fetchUserHandlerSelectionsSuccessActionCreator,
  deleteUserHandlerSelectionFailureActionCreator,
  deleteUserHandlerSelectionSuccessActionCreator,
} from '../../../../user/redux/actions/UserActions';
import { postHandler } from '../../api/HandlersApi';
import {
  handlerCheckedActionCreator,
  retrieveOutboundHandlersFailureActionCreator,
  retrieveOutboundHandlersSuccessActionCreator,
} from '../actions/HandlerActions';
import { RETRIEVE_OUTBOUND_HANDLER_REQUEST } from '../actions/types/HandlerActionTypes';

function* retrieveOutboundHandlerWorker(action) {
  const stretch = 'OUTBOUND';
  try {
    const handlersResponse = yield call(postHandler, {
      stretch,
      startDate: action.payload.startDate,
      endDate: action.payload.endDate,
    });

    yield put(retrieveOutboundHandlersSuccessActionCreator(handlersResponse.data));

    if (action.checkedHandlers && action.checkedHandlers.length) return;

    const lastUserHandlerSelectionResponse = yield call(userAPI.getLastUserHandlerSelection);
    const lastUserHandlerSelection = lastUserHandlerSelectionResponse.data;

    if (lastUserHandlerSelection) {
      yield put(handlerCheckedActionCreator(lastUserHandlerSelection.handlers));
    }
  } catch (error) {
    yield put(retrieveOutboundHandlersFailureActionCreator(error));
  }
}

function* fetchUserHandlerSelectionsWorker() {
  try {
    const userHandlerSelectionsResponse = yield call(userAPI.getUserHandlerSelections);
    const selections = userHandlerSelectionsResponse.data;

    yield put(fetchUserHandlerSelectionsSuccessActionCreator(selections));
  } catch (error) {
    yield put(fetchUserHandlerSelectionsFailureActionCreator(error));
  }
}

function* deleteUserHandlerSelectionsWorker(action) {
  try {
    yield call(userAPI.deleteUserHandlerSelection, action.payload);
    yield put(deleteUserHandlerSelectionSuccessActionCreator());
  } catch (error) {
    yield put(deleteUserHandlerSelectionFailureActionCreator(error));
  }
}

function* handlersWatcher() {
  yield takeLeading(RETRIEVE_OUTBOUND_HANDLER_REQUEST, retrieveOutboundHandlerWorker);
  yield takeLeading(FETCH_USER_HANDLER_SELECTIONS_REQUEST, fetchUserHandlerSelectionsWorker);
  yield takeEvery(DELETE_USER_HANDLER_SELECTION_REQUEST, deleteUserHandlerSelectionsWorker);
}

export default handlersWatcher;
